if (!customElements.get('shop-the-look')) {
  class ShopTheLook extends SwiperSlider {
    constructor() {
      super();
      this.shopLookProductsContainer = this.closest('.shop-look-column-wrapper');
      this.pointerWrappers = this.shopLookProductsContainer && this.shopLookProductsContainer.querySelectorAll('.product-pointer-wrapper');
    }

    connectedCallback() {
      super.connectedCallback();
    }

    initSwiper() {
      super.initSwiper();
      this.swiper.on('slideChange', () => {
        this.handleTransitionEnd();
      });
      this.changeSlide();
    }

    changeSlide() {
      if (!this.pointerWrappers.length) return;
      this.pointerWrappers.forEach((pointer) => {
        pointer.addEventListener('click', () => {
          const blockId = pointer.getAttribute('data-block-id');
          const targetSlide = this.querySelector('.swiper-slide[data-item-target="' + blockId + '"]');

          if (targetSlide && !!targetSlide.getAttribute('data-swiper-slide-index')) {
            this.swiper.slideToLoop(targetSlide.getAttribute('data-swiper-slide-index'), 500, true);
          } else {
            this.swiper.slideToLoop(targetSlide.getAttribute('data-index'), 500, true);
          }
        });
        this.swiper;
      });
    }

    handleTransitionEnd() {
      const activeSlide = this.swiper.slides[this.swiper.activeIndex];
      const activeBlockId = activeSlide.getAttribute('data-item-target');

      if (!this.pointerWrappers.length) return;
      this.pointerWrappers.forEach((pointer) => {
        pointer.classList.remove('active-pointer');
      });

      const activePointer = Array.from(this.pointerWrappers).find((pointer) => pointer.getAttribute('data-block-id') === activeBlockId);

      if (activePointer) {
        activePointer.classList.add('active-pointer');
      }
    }
  }

  customElements.define('shop-the-look', ShopTheLook);
}

if (!customElements.get('shop-the-look-height')) {
  class ShopTheLookHeight extends HTMLElement {
    constructor() {
      super();
      this.containerHeightAdapt = this.classList.contains('shop-look-section--adapt');
      this.image = this.querySelector('.shop-look__media');
    }

    connectedCallback() {
      if (this.containerHeightAdapt && this.image) {
        this.setContainerHeight();
        window.addEventListener('resize', this.setContainerHeight.bind(this));
      }
    }

    setContainerHeight() {
      if (window.matchMedia('(min-width: 990px)')) {
        document.documentElement.style.setProperty('--shop-look-height', `${this.image.offsetHeight}px`);
      }
    }
  }
  customElements.define('shop-the-look-height', ShopTheLookHeight);
}
